import React, { useState } from 'react';
import { Button, Popconfirm, Space, Typography, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import api from '../services/api';

const { Title, Text } = Typography;

const RestartGateway = () => {
  const [loadingAction, setLoadingAction] = useState('');

  const runRestart = async (endpoint, successMsg) => {
    setLoadingAction(endpoint);
    try {
      const response = await api.post(endpoint);
      if (response.data.success) {
        message.success(response.data.message || successMsg);
      } else {
        message.error('重启失败');
      }
    } catch (error) {
      console.error('重启失败:', error);
      const errorMessage = error.response?.data?.detail || '重启失败，请检查网络连接';
      message.error(errorMessage);
    } finally {
      setLoadingAction('');
    }
  };

  const confirmText = '确认执行重启操作吗？重启期间IB连接会暂时中断。';

  return (
    <div
      style={{
        padding: '24px',
        background: '#fff',
        maxWidth: '600px',
        margin: '0 auto',
      }}
    >
      <Title level={3} style={{ marginBottom: '16px' }}>
        重启IB Gateway
      </Title>
      <Text style={{ display: 'block', marginBottom: '24px', color: '#666' }}>点击下方按钮将重启IB Gateway服务。请按需选择重启单个账户或重启全部账户。</Text>

      <Space direction="vertical" style={{ width: '100%' }} size={12}>
        <Popconfirm title="确认重启" description={confirmText} okText="确认" cancelText="取消" onConfirm={() => runRestart('/admin/restart-gateway-gyt', 'IB_GYT 重启命令已发送')}>
          <Button
            type="primary"
            size="large"
            icon={<ReloadOutlined />}
            loading={loadingAction === '/admin/restart-gateway-gyt'}
            style={{
              width: '100%',
              height: '48px',
              fontSize: '16px',
              borderRadius: '6px',
            }}
          >
            {loadingAction === '/admin/restart-gateway-gyt' ? '重启中...' : '重启IB_GYT'}
          </Button>
        </Popconfirm>

        <Popconfirm title="确认重启" description={confirmText} okText="确认" cancelText="取消" onConfirm={() => runRestart('/admin/restart-gateway-gil', 'IB_GIL 重启命令已发送')}>
          <Button
            type="primary"
            size="large"
            icon={<ReloadOutlined />}
            loading={loadingAction === '/admin/restart-gateway-gil'}
            style={{
              width: '100%',
              height: '48px',
              fontSize: '16px',
              borderRadius: '6px',
            }}
          >
            {loadingAction === '/admin/restart-gateway-gil' ? '重启中...' : '重启IB_GIL'}
          </Button>
        </Popconfirm>

        <Popconfirm title="确认重启" description={confirmText} okText="确认" cancelText="取消" onConfirm={() => runRestart('/admin/restart-gateway', '重启所有IB账户命令已发送')}>
          <Button
            size="large"
            icon={<ReloadOutlined />}
            loading={loadingAction === '/admin/restart-gateway'}
            style={{
              width: '100%',
              height: '48px',
              fontSize: '16px',
              borderRadius: '6px',
            }}
          >
            {loadingAction === '/admin/restart-gateway' ? '重启中...' : '重启所有IB账户'}
          </Button>
        </Popconfirm>
      </Space>
    </div>
  );
};

export default RestartGateway;
